import { Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Table, Form, Empty } from 'antd';
import { useSelector } from 'react-redux'
import { getObjective } from '../../../libs/todoSlice'
import { resolvePreRegisterConfig, buildFieldColumns } from '../../../lib/preRegisterConfig'

/**
 * แสดงรายการที่ลงทะเบียนสำเร็จ (หลังกด "ดำเนินการสร้าง" ใน PreRegisterAddMember.jsx)
 * Generic — ใช้ config.fields จาก preRegisterConfig.jsx เพื่อ derive columns
 * ตามประเภทที่กำลังใช้งานอยู่ (thaid / thaidGeneralForm / ประเภทอื่นในอนาคต)
 *
 * TODO: ยืนยัน field จริงใน response.data ที่ backend คืนกลับมาหลังยืนยันสำเร็จ
 * (ตอนนี้แสดงตาม config.fields ที่ส่งไปตอน request เท่านั้น)
 */
const PreRegisterAddMemberSuccess = ({ memberOneSuccess }) => {
    const objective = useSelector(getObjective)
    const config = resolvePreRegisterConfig(objective)
    const [form] = Form.useForm();
    const [data, setData] = useState([]);

    useEffect(() => {
        

        setData(memberOneSuccess.map((members, index) => ({
            index: index + 1,
            ...Object.fromEntries(config.fields.map(f => [f.key, members.request?.[f.key]])),
        })))
    }, [memberOneSuccess, config])

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };

    const columns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            fixed: 'left',
            render: (__, _, index) => index + 1,
        },
        ...buildFieldColumns(config),   // read-only — ไม่ส่ง editable/isEditing/data/setData
    ];

    return (
        <Row>
            <Form form={form} component={false}>
                <Table
                    locale={customLocale}
                    bordered
                    dataSource={data}
                    columns={columns}
                    rowKey="index"
                    rowClassName="editable-row"
                    scroll={{ x: 900, y: 400 }}
                />
            </Form>
        </Row>
    )
}
export default PreRegisterAddMemberSuccess